function addToCartNew(variantId, quantity = 1) {
    console.log("a")
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,   // Variant ID
      quantity: quantity
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log("Added to cart:", data);
  })
  .catch(err => console.error("Error adding to cart:", err));
}

document.addEventListener("DOMContentLoaded", function () {
    var thumbsSwiper = new Swiper(".thumbs-swiper", {
        direction: "vertical",
        loop: false,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-nextmain",
            prevEl: ".swiper-button-prevmain",
        },
        // on: {
        //     init: function () {
        //         toggleNavButtons(this);
        //     },
        //     slideChange: function () {
        //         toggleNavButtons(this);
        //     }
        // },
        breakpoints: {
            0: {
                spaceBetween: 8
            },
            768: {
                spaceBetween: 5
            }
        },
    });

    var mainSwiper = new Swiper(".main-swiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        thumbs: {
            swiper: thumbsSwiper,
        },
    });




    document.querySelectorAll(".quantity").forEach(function (wrapper) {
        const minusBtn = wrapper.querySelector(".minus");
        const plusBtn = wrapper.querySelector(".plus");
        const qtyInput = wrapper.querySelector("input[type='text']");

        if (!qtyInput) return;

        minusBtn.addEventListener("click", function () {
            let currentVal = parseInt(qtyInput.value) || 1;
            let min = parseInt(qtyInput.min) || 1;
            if (currentVal > min) {
                qtyInput.value = currentVal - 1;
                qtyInput.dispatchEvent(new Event("change")); // Shopify/cart sync
            }
        });

        plusBtn.addEventListener("click", function () {
            let currentVal = parseInt(qtyInput.value) || 1;
            let max = parseInt(qtyInput.max) || 9999;
            if (currentVal < max) {
                qtyInput.value = currentVal + 1;
                qtyInput.dispatchEvent(new Event("change")); // Shopify/cart sync
            }
        });
    });


    // function toggleNavButtons(swiper) {
    //     let prevBtn = document.querySelector(".swiper-button-prevmain");
    //     let nextBtn = document.querySelector(".swiper-button-nextmain");

    //     if (prevBtn) {
    //         if (swiper.isBeginning) {
    //             prevBtn.style.display = "none";
    //         } else {
    //             prevBtn.style.display = "flex";
    //         }
    //     }

    //     if (nextBtn) {
    //         if (swiper.isEnd) {
    //             nextBtn.style.display = "none";
    //         } else {
    //             nextBtn.style.display = "flex";
    //         }
    //     }
    // }
});

document.addEventListener("DOMContentLoaded", function () {
    var customSelect = document.getElementById("customSelect");
    if (!customSelect) return;
    var open_section = customSelect.querySelector(".select-trigger_dd");
    var trigger = customSelect.querySelector(".select-trigger");
    var options = customSelect.querySelector(".select-options");
    if (!open_section || !options) return;

    open_section.addEventListener("click", () => {
        options.style.display = options.style.display === "block" ? "none" : "block";
    });

    options.querySelectorAll("li").forEach(option => {
        option.addEventListener("click", () => {
            trigger.textContent = option.textContent;
            options.style.display = "none";
        });
    });

    document.addEventListener("click", (e) => {
        if (!customSelect.contains(e.target)) {
            options.style.display = "none";
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
    const options = document.querySelectorAll(".select-options li");

    options.forEach(option => {
        option.addEventListener("click", function () {
            options.forEach(opt => opt.classList.remove("active1"));
            this.classList.add("active1");
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    let radios = document.querySelectorAll('.buy-options input[type="radio"]');

    radios.forEach(radio => {
        radio.addEventListener('change', function () {
            document.querySelectorAll('.option').forEach(opt => opt.classList.remove('selected'));
            let label = document.querySelector(`label[for="${this.id}"]`);
            if (label) {
                label.classList.add('selected');
            }

            priceAdjustment();
        });
    });
    let checked = document.querySelector('.buy-options input[type="radio"]:checked');
    if (checked) {
        let label = document.querySelector(`label[for="${checked.id}"]`);
        if (label) {
            label.classList.add('selected');
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.querySelector(".dropdown");
    if (!dropdown) return;
    const dropdownLabel = dropdown.querySelector(".dropdown-label span");
    const dropdownMenu = dropdown.querySelector(".dropdown-menu");
    const dropdownItems = dropdown.querySelectorAll(".dropdown-item");
    dropdown.addEventListener("click", function (e) {
        e.stopPropagation();
        dropdown.classList.toggle("is-active");
    });

    window.subscription_discount = parseInt(dropdownItems[0].getAttribute("data-discount"));
    window.planId = parseInt(dropdownItems[0].getAttribute("data-selling-plan-id"));
    dropdownItems.forEach((item) => {
        item.addEventListener("click", function (e) {
            e.stopPropagation();
            let selectedText = this.innerText;
            let selectedValue = this.dataset.value;
            dropdownLabel.textContent = selectedText;
            dropdown.classList.remove("is-active");
            console.log("Selected Value:", selectedValue);
            window.subscription_discount = parseInt(this.dataset.discount);
            window.planId = parseInt(this.getAttribute("data-selling-plan-id"));
            priceAdjustment();
        });
    });
    document.addEventListener("click", function () {
        dropdown.classList.remove("is-active");
    });


});


document.getElementById("dropdownBtn")
? document.getElementById("dropdownBtn").addEventListener("click", function () {
    this.classList.toggle("active");
    let content = document.getElementById("dropdownContent");
    if (content.style.display === "block") {
        content.style.display = "none";
    } else {
        content.style.display = "block";
    }
}): "";





const optionLabels = document.querySelectorAll('.buy-options .option');
const hiddenInput = document.getElementById('product_options_new');

optionLabels.forEach(label => {
    label.addEventListener('click', function (e) {
        const radioInput = label.querySelector('input[type="radio"]');
        if (radioInput) {
            radioInput.checked = true;
            hiddenInput.value = radioInput.value;
            optionLabels.forEach(l => l.classList.remove('selected'));
            label.classList.add('selected');
        }
        priceAdjustment();
    });
});
const checkedRadio = document.querySelector('.buy-options input[type="radio"]:checked');
if (checkedRadio) {
    hiddenInput.value = checkedRadio.value;
    checkedRadio.closest('.option').classList.add('selected');
}




var radios = document.querySelectorAll('input[type="radio"][name="Subscription"]');
function updateSelection() {
    document.querySelectorAll('.option-container').forEach(label => {
        label.classList.remove('selected');
    });
    radios.forEach(radio => {
        if (radio.checked) {
            radio.closest('.option-container').classList.add('selected');
        }
    });
} radios.forEach(radio => {
    radio.addEventListener('change', updateSelection);
});
updateSelection();




document.addEventListener("DOMContentLoaded", function () {
    function attachEvents() {
        const oneTimeLabel = document.querySelector("#One-Time-Purchase");
        if (oneTimeLabel) {
            oneTimeLabel.addEventListener("click", function () {
                const rcOneTime = document.querySelector('label[data-label-onetime]');
                if (rcOneTime) {
                    rcOneTime.click();
                }
                // document.querySelector('.option-container .wrapper').style.display = 'none';
                document.querySelectorAll('.option-container .option-list li').forEach(function(el) {
                    el.style.color = '#061C99';
                });
                // document.querySelector('.option-container .dropdown-wrapper').style.display = 'none';
                // document.querySelector('.option-container .option-old-price').style.display = 'none';
                priceAdjustment()
            });
        }

        const subsLabels = document.querySelectorAll("#SubscriptionPurchase");
        subsLabels.forEach(function (input) {
            const parentLabel = input.closest("label");
            if (parentLabel) {
                parentLabel.addEventListener("click", function () {
                    const rcSub = document.querySelector('label[data-label-subsave]');
                    if (rcSub) {
                        rcSub.click();

                    }
                    document.querySelectorAll('.option-container .option-list li').forEach(function(el) {
                        el.style.color = '#66666B';
                    });
                    // document.querySelector('.option-container .wrapper').style.display = 'flex';
                    // document.querySelector('.option-container .option-list').style.display = 'flex';
                    // document.querySelector('.option-container .dropdown-wrapper').style.display = 'flex';
                    // document.querySelector('.option-container .option-old-price').style.display = 'flex';
                    priceAdjustment()
                });
            }
        });
    }
    attachEvents();
});

document.addEventListener('DOMContentLoaded', function () {
    const metaItems = document.querySelectorAll('.meta-product-item');
    var content_box = document.querySelector('#dropdownContent');
    var dropdownBtn = document.querySelector('#dropdownBtn');
    const textChangeEl = document.querySelector('.text_change'); // वो element जहाँ text दिखाना है

    metaItems.forEach(item => {
        const label = item.querySelector('label');
        const input = item.querySelector('input');

        label.addEventListener('click', function () {
            metaItems.forEach(i => i.querySelector('input').checked = false);
            metaItems.forEach(i => i.querySelector('label').classList.remove('selected'));
            input.checked = true;
            label.classList.add('selected');
            if (textChangeEl) {
                content_box.style.display = 'none';
                dropdownBtn.classList.remove('active')
                textChangeEl.textContent = label.textContent.trim();
            }
        });
    });
    const firstSelected = document.querySelector('.meta-product-item label.selected');
    if (firstSelected && textChangeEl) {
        textChangeEl.textContent = firstSelected.textContent.trim();
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const selectBox = document.querySelector("#customSelect");
    if (!selectBox) return;
    const trigger = selectBox.querySelector(".select-trigger");
    const options = selectBox.querySelectorAll(".size_text");
    const savedValue = localStorage.getItem("selectedSize");
    // IM Oct 2026: a ?variant= link (ads, feeds, shared links) wins over the last size the visitor picked
    if (savedValue && !/[?&]variant=/.test(location.search)) {
        trigger.textContent = savedValue;

        options.forEach(option => {
            option.classList.remove("active1");
            if (option.dataset.value === savedValue) {
                option.classList.add("active1");
            }
        });
    } else {
        const activeOption = selectBox.querySelector(".size_text.active1");
        if (activeOption) trigger.textContent = activeOption.dataset.value;
    }

    options.forEach(option => {
        option.addEventListener("click", function () {
            options.forEach(opt => opt.classList.remove("active1"));
            this.classList.add("active1");

            trigger.textContent = this.dataset.value;
            localStorage.setItem("selectedSize", this.dataset.value);
        });
    });
});

function priceAdjustment() {
    if (!document.querySelector("[name='quantity']") || !document.querySelector('.buy-options input:checked') || !document.querySelector('[name="Subscription"]:checked') || !document.querySelector('#master_select')) return;
    var prodct_price = "";
    var qty = parseInt(document.querySelector("[name='quantity']").value);
    var subscription_discount = window.subscription_discount;
    var product_discount = parseInt(document.querySelector(".buy-options input:checked").getAttribute("data-discount"));
    var comparePrice = "";
    var isSubscription = document.querySelector('[name="Subscription"]:checked').value == 'subscribe' ? true : false;

    var masterSelect = document.querySelector("#master_select");
    masterSelect.querySelectorAll("option").forEach(function (option) {
        if (option.getAttribute("value") == masterSelect.value) {
            prodct_price = parseInt(option.getAttribute("data-price-absolute"));
            comparePrice = option.getAttribute("data-compare-absolute");
        }
    })

    var mainPrice = "$" + (((prodct_price * qty * (1 - (subscription_discount/ 100.00))*(1 - (product_discount/ 100.00)))) / 100.00).toFixed(2);
    // Bundle discount is rounded down to the cent at checkout, so the one-time price rounds up to match the cart
    var oneTimeCents = prodct_price * qty - Math.floor(prodct_price * qty * product_discount / 100);
    var mainCompare = "$" + (oneTimeCents / 100).toFixed(2);
    var compareAtPrice = "$" + ((prodct_price * qty / 100.00)).toFixed(2);

    console.log(mainPrice, mainCompare)

   


    document.querySelectorAll(".product-price_main .price_main-prce").forEach(function (el) {
        el.textContent = mainPrice;
        if (!isSubscription) {
            el.textContent = mainCompare;
        }
    });

    document.querySelectorAll(".product-price_main .compare").forEach(function (compare) {
        compare.textContent = mainCompare;
        if (isSubscription) {
            compare.style.display = 'block'
        }else{
            compare.style.display = 'none'
        }
    });


    document.querySelectorAll("#SubscriptionPurchase .discounted_price_s").forEach(function (discounted_price_s) {
        discounted_price_s.textContent = mainPrice;
    });

    document.querySelectorAll("#SubscriptionPurchase .option-old-price").forEach(function (Scompare) {
        Scompare.textContent = mainCompare;
    });

    document.querySelectorAll("#One-Time-Purchase .option-price").forEach(function (Scompare) {
        Scompare.textContent = mainCompare;
    });


    document.querySelectorAll(".option-priceold_price").forEach(function (el) {
        el.textContent = compareAtPrice;
    });

    document.querySelectorAll(".option-price .option-old-price").forEach(function (old) {
        old.textContent = compareAtPrice;
    });

    document.querySelectorAll(".product-price_main .compare").forEach(function (main) {
        main.textContent = compareAtPrice;
    });
}


document.querySelector("[name='quantity']")?.addEventListener("change", function () {
    priceAdjustment()
})


document.querySelectorAll(".Add_to_btn").forEach(function(btn){
    btn.addEventListener("click", function(e){
        if (!document.querySelector('[name="Subscription"]:checked')) return;
        e.preventDefault();
        var items = [];
        var productID = parseInt(document.querySelector("#master_select").value);
        var productQTY = parseInt(document.querySelector("[name='quantity']").value);
        var isSubscription = document.querySelector('[name="Subscription"]:checked').value == 'subscribe' ? true : false;
        if (isSubscription) {
            var variantId = parseInt(document.querySelector('.meta-product-item input:checked').value);
            console.log(variantId);
            items.push({
               id:variantId,
               quantity: 1
            })

            items.push({
                id: productID,
                quantity: productQTY,
                selling_plan: window.planId
            })
            // addToCartNew(variantId, 1);
        }else{
           items.push({
                id: productID,
                quantity: productQTY
            }) 
        }

        console.log(items)


        jQuery.post('/cart/add.js', {
            items: items
        });
    })
})

document.addEventListener("DOMContentLoaded", function () {
  const qtyInput = document.querySelector("input[type='text']");
  if (!qtyInput) return;
  qtyInput.addEventListener("input", checkQty);
  qtyInput.addEventListener("change", checkQty);
  function checkQty() {
    let val = parseInt(qtyInput.value, 10);
    let targetFor = null;

    if (val === 1) targetFor = "Buy1";
    else if (val === 3) targetFor = "Buy2";
    else if (val === 6) targetFor = "Buy3";

    if (targetFor) {
      const label = document.querySelector(`label[for='${targetFor}']`);
      if (label) label.click();
    }
  }
  checkQty();
});


document.addEventListener("DOMContentLoaded", function () {
  const buy3Label = document.querySelector('label[for="Buy2"]');
  const discountLi = document.querySelector('.option-list.One-Time li');
  if (buy3Label && discountLi) {
    buy3Label.addEventListener("click", function () {
      discountLi.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7613 0.845072C11.9017 0.985692 11.9806 1.17632 11.9806 1.37507C11.9806 1.57382 11.9017 1.76444 11.7613 1.90507L4.5113 9.15507C4.37067 9.29547 4.18005 9.37437 3.9813 9.37437C3.78255 9.37437 3.59192 9.29547 3.4513 9.15507L0.201296 5.90507C0.0688163 5.76289 -0.0033037 5.57485 0.000116305 5.38054C0.0035463 5.18624 0.0822562 5.00086 0.219676 4.86344C0.357086 4.72603 0.542476 4.64732 0.736776 4.64389C0.931076 4.64046 1.11912 4.71259 1.2613 4.84507L3.9813 7.56507L10.7013 0.845072C10.8419 0.704622 11.0325 0.625732 11.2313 0.625732C11.43 0.625732 11.6207 0.704622 11.7613 0.845072Z" fill="#061C99"></path>
        </svg> 
        5% OFF
      `;
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const buy3Label = document.querySelector('label[for="Buy3"]');
  const discountLi = document.querySelector('.option-list.One-Time li');
  if (buy3Label && discountLi) {
    buy3Label.addEventListener("click", function () {
      discountLi.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7613 0.845072C11.9017 0.985692 11.9806 1.17632 11.9806 1.37507C11.9806 1.57382 11.9017 1.76444 11.7613 1.90507L4.5113 9.15507C4.37067 9.29547 4.18005 9.37437 3.9813 9.37437C3.78255 9.37437 3.59192 9.29547 3.4513 9.15507L0.201296 5.90507C0.0688163 5.76289 -0.0033037 5.57485 0.000116305 5.38054C0.0035463 5.18624 0.0822562 5.00086 0.219676 4.86344C0.357086 4.72603 0.542476 4.64732 0.736776 4.64389C0.931076 4.64046 1.11912 4.71259 1.2613 4.84507L3.9813 7.56507L10.7013 0.845072C10.8419 0.704622 11.0325 0.625732 11.2313 0.625732C11.43 0.625732 11.6207 0.704622 11.7613 0.845072Z" fill="#061C99"></path>
        </svg> 
        10% OFF
      `;
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('.dropdown-menu .dropdown-item');
    items.forEach(item => {
        if(item.textContent.trim() === "Delivery every 30 days") {
            item.click();
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.buy-options label');
    const optionTitleSpan = document.querySelector('.option-title strong span');
    labels.forEach(label => {
        label.addEventListener('click', function() {
            const saveText = this.getAttribute('data-save');
            if(optionTitleSpan) {
                optionTitleSpan.textContent = saveText;
            }
        });
    });
});


document.querySelector('#BestSeller')?.addEventListener('click', function () {
    document.querySelector('.latest_text')?document.querySelector('.latest_text').style.display = "flex" : '';
    document.querySelector('.option-list.One-Time')?document.querySelector('.option-list.One-Time').style.display = "flex" : '';
    document.querySelector('.option-priceold_price')?document.querySelector('.option-priceold_price').style.display = "flex" : '';
    document.querySelector('.product-price_main .compare')?document.querySelector('.product-price_main .compare').style.display = "flex": '';
    document.querySelector('.Free_Shipping')?document.querySelector('.Free_Shipping').style.display = "flex" : '';
});

document.querySelector('.description_ss')?.addEventListener('click', function () {
    document.querySelector('.latest_text')?document.querySelector('.latest_text').style.display = "none" : '';
    document.querySelector('.option-list.One-Time')?document.querySelector('.option-list.One-Time').style.display = "none" : '';
    document.querySelector('.Free_Shipping')?document.querySelector('.Free_Shipping').style.display = "none" : '';
    document.querySelector('.option-priceold_price')?document.querySelector('.option-priceold_price').style.display = "none" : '';
    document.querySelector('.product-price_main .compare')?document.querySelector('.product-price_main .compare').style.display = "none" : '';
});

document.querySelector('.Best_Value')?.addEventListener('click', function () {
    document.querySelector('.Free_Shipping')?document.querySelector('.Free_Shipping').style.display = "flex" : '';
     document.querySelector('.option-list.One-Time')?document.querySelector('.option-list.One-Time').style.display = "flex" : '';
    document.querySelector('.option-priceold_price')?document.querySelector('.option-priceold_price').style.display = "flex" : '';
    document.querySelector('.product-price_main .compare')?document.querySelector('.product-price_main .compare').style.display = "flex" : '';
});




document.querySelector('#BestSeller') && window.addEventListener('scroll', function() {
    const buttons = document.querySelectorAll('.Add_to_btn');
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    buttons.forEach(function(btn) {
        if(scrollTop > 1100 && (scrollTop + windowHeight < docHeight - 1500)) {
            btn.classList.add('Add_to_btn_sticky');
        } else {
            btn.classList.remove('Add_to_btn_sticky');
        }
    });
});





function changeswiperimage(value) {
    if (!value) return;
    var all = $('.all_images .gallery_data');
    var all_nav = $('.all_nav_images .gallery_data');
    var total_html = '';
    var total_nav = '';

    var selectedVariant = value.toLowerCase().trim();

    for (let i = 0; i < all.length; i++) {
        const element = all[i];
        var alttag = $(element).attr('data-alt').toLowerCase().trim();

        if (alttag === selectedVariant || alttag === 'all') {
            total_html += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(element).html()}</div>`;
            total_nav += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(all_nav[i]).html()}</div>`;
        } else if (alttag === '5layers' && selectedVariant.includes('5 layers') && !selectedVariant.includes('crib')) {
            total_html += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(element).html()}</div>`;
            total_nav += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(all_nav[i]).html()}</div>`;
        } else if (alttag === '7layers' && selectedVariant.includes('7 layers')) {
            total_html += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(element).html()}</div>`;
            total_nav += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(all_nav[i]).html()}</div>`;
        } else if (alttag === 'crib' && selectedVariant.includes('crib')) {
            total_html += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(element).html()}</div>`;
            total_nav += `<div class="gallery_data swiper-slide" data-alt="${alttag}">${$(all_nav[i]).html()}</div>`;
        }
    }

    if (total_html !== '' && total_nav !== '') {
        // 1. Destroy any existing Swiper instances on the containers
        var mainContainer = $('.main-swiper')[0];
        var thumbsContainer = $('.thumbs-swiper')[0];

        if (mainContainer && mainContainer.swiper) {
            mainContainer.swiper.destroy(true, false);
        }
        if (thumbsContainer && thumbsContainer.swiper) {
            thumbsContainer.swiper.destroy(true, false);
        }

        // 2. Update the slide HTML
        $('.main-swiper .swiper-wrapper').html(total_html);
        $('.thumbs-swiper .swiper-wrapper').html(total_nav);

        // 3. Initialise fresh Swipers
        var thumbsSwiper = new Swiper(".thumbs-swiper", {
            direction: "vertical",
            loop: false,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".swiper-button-nextmain",
                prevEl: ".swiper-button-prevmain",
            },
            breakpoints: {
                0: { spaceBetween: 8 },
                768: { spaceBetween: 5 }
            },
        });

        var mainSwiper = new Swiper(".main-swiper", {
            slidesPerView: 1,
            spaceBetween: 10,
            autoHeight: true,
            thumbs: {
                swiper: thumbsSwiper,
            },
        });
    }
}
